import { STORAGE_KEYS } from '../constants/storageKeys';
import { DEFAULT_PROGRESS } from '../constants/defaultProgress';

export const loadProgressFromStorage = () => {
  try {
    const saved = localStorage.getItem(STORAGE_KEYS.PROGRESS);
    if (!saved) return { ...DEFAULT_PROGRESS };

    const parsed = JSON.parse(saved);

    // Merge con defaults para no romper si faltan keys viejas
    return {
      ...DEFAULT_PROGRESS,
      ...parsed,
      unlockedSkins: parsed.unlockedSkins || DEFAULT_PROGRESS.unlockedSkins,
      currentSkin: parsed.currentSkin || DEFAULT_PROGRESS.currentSkin,
      unlockedContent: parsed.unlockedContent || DEFAULT_PROGRESS.unlockedContent,
      completedSets: parsed.completedSets || DEFAULT_PROGRESS.completedSets,
      xp: parsed.xp ?? DEFAULT_PROGRESS.xp,
    };
  } catch (e) {
    // Si el JSON está corrupto, vuelve a default
    return { ...DEFAULT_PROGRESS };
  }
};

export const saveProgressToStorage = (newData) => {
  localStorage.setItem(STORAGE_KEYS.PROGRESS, JSON.stringify(newData));
};

export const loadTeacherModeFromStorage = () => {
  return localStorage.getItem(STORAGE_KEYS.TEACHER_MODE) === 'true';
};

export const saveTeacherModeToStorage = (enabled) => {
  localStorage.setItem(STORAGE_KEYS.TEACHER_MODE, enabled ? 'true' : 'false');
};
